export default function () {
  var backToTopButton = document.querySelector('.js-back-to-top')

  // Show or hide the button
  window.addEventListener('scroll', function () {
    if (window.scrollY > 300) {
      backToTopButton.classList.remove('back-to-top--hidden')
    } else {
      backToTopButton.classList.add('back-to-top--hidden')
    }
  })

  // Scroll to top when the button is clicked
  backToTopButton.addEventListener('click', function () {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    })
  })
}
